"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlarmTitle = AlarmTitle;
var jsx_runtime_1 = require("react/jsx-runtime");
function AlarmTitle(props) {
    var alarmName = props.alarmName, priority = props.priority;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-2xl font-bold text-dark-gray-1", children: alarmName }), priority && ((0, jsx_runtime_1.jsx)("p", { className: "text-sm font-medium ".concat(priority.toLowerCase() === "high" ? "text-red-600" : "text-medium-gray"), children: priority.toLocaleUpperCase() }))] }));
}
